module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Regular.1d31e74.eot";